import { render, staticRenderFns } from "./PricingContent.vue?vue&type=template&id=0afeb8df&"
import script from "./PricingContent.vue?vue&type=script&lang=js&"
export * from "./PricingContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports